import React, { useRef, useState } from 'react';
import { Grid, Typography, TextField, Button } from '@mui/material';
import { fetchPost } from '../../api/common';
import './styles.css';

export const ForgotPassword = () => {
  const emailRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (event: any) => {
    //Prevent page reload
    event.preventDefault();
    if (!emailRef.current) {
      setError('Type an email');
      return;
    }

    try {
      const res = await fetchPost('/authenticate/forgot-password', {
        email: emailRef.current.value,
      });
      console.log('forgot pass res', res);
      if (res) {
        setError('');
        setMessage('Please check your email');
        setEmailSent(true);
      }
    } catch {
      setMessage('');
      setError('Failed to send email');
      setEmailSent(false);
    }
  };

  const renderErrorMessage = () => (
    <Typography color="error.main">{error}</Typography>
  );

  const renderMessage = () => (
    <Typography color="success.main">{message}</Typography>
  );

  return (
    <>
      <Grid item>{renderErrorMessage()}</Grid>
      <Grid item>{renderMessage()}</Grid>
      <Grid item>
        <Typography sx={{ marginBottom: '24px' }}>
          What is your email?
        </Typography>
      </Grid>
      <Grid item>
        <form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                type="email"
                placeholder="Email"
                fullWidth
                variant="outlined"
                name="email"
                inputRef={emailRef}
                disabled={emailSent}
                required
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="button-block"
                disabled={emailSent}
              >
                Reset Password
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
};
